<template>
  <div class="picker" :class="{ 'picker--readonly': readonly }">
    <a-row :gutter="12">
      <a-col :span="12">
        <span>Usuarios</span>
        <CustomScrollbar class="panel panel--left" :height="`${height}px`">
          <a-input ref="searchInput" placeholder="Buscar usuarios" @change="handleSearchUsers">
            <template #prefix>
              <SearchOutlined />
            </template>
            <template #suffix>
              <a-tooltip title="Extra information"> </a-tooltip>
            </template>
          </a-input>
          <div class="field">
            <a-checkbox v-model:checked="selectedAll"> Seleccionar todos</a-checkbox>
          </div>
          <div v-for="item in filteredUsers" :key="item.id" class="field">
            <a-checkbox :checked="isActive(item)" @change="handleToggle($event, item)">
              {{ item?.fullname || item?.full_name }}
            </a-checkbox>
          </div>
        </CustomScrollbar>
      </a-col>
      <a-col :span="12">
        <span>Seleccionados</span>
        <CustomScrollbar class="panel panel--high" :height="`${height}px`">
          <div
            v-for="item in selecteds"
            :key="item?.fullname || item?.full_name"
            class="block__item"
          >
            <span>{{ item?.fullname || item?.full_name }}</span>
            <!-- <a-icon
              v-if="!readonly"
              class="block__icon"
              type="close"
              @click="handleRemove(item)"
            /> -->
            <CloseOutlined v-if="!readonly" class="block__icon" @click="handleRemove(item)" />
          </div>
        </CustomScrollbar>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    CustomScrollbar,
    CloseOutlined,
    SearchOutlined,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    height: {
      required: false,
      type: Number,
      default: 280,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selecteds: [],
      searchUser: "",
    };
  },
  watch: {
    value(value) {
      this.selecteds = value;
    },
  },
  computed: {
    selectedAll: {
      get() {
        if (this.items.length == 0) return false;
        if (this.items.length == this.selecteds.length) return true;
        else return false;
      },
      set(value) {
        if (value) {
          this.selecteds = [...this.items];
        } else {
          this.selecteds = [];
        }
        this.$emit("update:value", this.selecteds);
        this.$emit("change");
      },
    },
    filteredUsers() {
      return this.items.filter((item) => {
        const itemKey = item?.fullname ? "fullname" : "full_name";

        return item?.[itemKey]?.toLowerCase().match(this.searchUser.toLowerCase());
      });
    },
  },
  methods: {
    handleSearchUsers(event) {
      this.searchUser = event.target.value;
    },
    isActive(item) {
      return !!this.selecteds.find((selectedItem) => selectedItem.id === item.id);
    },
    handleToggle(event, item) {
      if (event.target.checked) {
        this.selecteds = [...this.selecteds, item];
      } else {
        const filteredItems = this.selecteds.filter((selectedItem) => {
          return selectedItem.id !== item.id;
        });
        this.selecteds = filteredItems;
      }
      this.$emit("update:value", this.selecteds);
      this.$emit("change");
    },
    handleRemove(item) {
      const filteredItems = this.selecteds.filter((selectedItem) => {
        return selectedItem.id !== item.id;
      });
      this.selecteds = filteredItems;
      this.$emit("update:value", this.selecteds);
      this.$emit("change");
    },
  },
};
</script>

<style lang="sass" scoped>
.picker
  margin: 12px auto
  user-select: none

  &--readonly
    & .panel--left
      opacity: 0.5

.panel
  padding: 12px
  margin: 4px 0
  border-radius: 2px
  border: $border-normal

  &--high
    padding: 4px 8px

.field
  padding: 4px 0

.block
  margin-bottom: 12px

  &__item
    font-size: 12px
    display: flex
    align-items: center
    justify-content: space-between
    background-color: $blue-1
    border: 1px solid $blue-3
    border-radius: 2px
    padding: 2px 8px
    margin: 4px 0

  &__icon
    font-size: 10px
</style>
